module.exports = __webpack_public_path__ + "fonts/SourceHanSansSC-Bold-subset.fe67a678.woff2";